// extracted by mini-css-extract-plugin
module.exports = {"copyField":"CopyField_copyField__Mj6mm"};